import { faFile, faFileAlt, faPrint, faSave, faSearch } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box, Button, CircularProgress, FormControl, MenuItem, Pagination, Select, Skeleton, TextField } from '@mui/material'
import React, { useEffect, useState } from 'react'
import Page from '../../component/Page'
import api from '../../api/api'
import dayjs from 'dayjs'
import { useNavigate, useSearchParams } from 'react-router-dom'
import Swal from 'sweetalert2'
import { SALE_CONFIG } from './config'
import { useSelector } from 'react-redux'
import { MobileDatePicker } from '@mui/x-date-pickers'
const BrowserInput = function BrowserInput(props) {
    const { inputProps, InputProps, ownerState, value, inputRef, error, ...other } = props;
    return (
        <TextField {...inputProps} ref={inputRef} value={value ? value.substring(0, value?.length - 6) + (parseInt(value?.substring(value?.length - 6)) + 543).toString() : ''} {...other} variant="standard" fullWidth
            InputProps={{
                disableUnderline: true,
            }}
        />
    );
};
export default function CoppyList() {
    // const [branchsNo, setBranchsNo] = useState('all')
    const { profile } = useSelector(state => state.profile)
    const [searchParams, setSearchParams] = useSearchParams()
    let q = searchParams.get('q') || ''
    let branchsNo = searchParams.get('b') || ''
    let id = searchParams.get('id') || ''
    let page = searchParams.get('page') || '1'
    let date = searchParams.get('date') || null
    const [data, setData] = useState([])
    const [branchs, setBranchs] = useState([])
    const [loadingPDF, setLoadingPDF] = useState(false)
    const [loading, setLoading] = useState(false);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const navigate = useNavigate()

    const getData = async () => {
        setLoading(true)
        const res = await api.get(`sale/dois?doiNo=${q}&branchNo=${profile?.BranchNo?.BranchNo === '00' ? branchsNo === 'all' ? '' : branchsNo  : profile?.BranchNo?.BranchNo}&sdate=${date !== 'null' && date !== null ? date  : ''}&edate=${date !== 'null' && date !== null ? date : ''}&page=${page}&limit=${rowsPerPage}`)
        const data = await res.data.result
        if (res.data.status === true) {
            setData(data)
            setLoading(false)
        }
    }
    const getBranchs = async () => {
        const res = await api.get(`dbms/branchs`)
        const data = await res.data.result
        if (res.data.status === true) {
            setBranchs(data)
        }
    }

    useEffect(() => {
        getBranchs()
    }, [])
    useEffect(() => {
        if(profile){
            getData()
        }
        
    }, [branchsNo, page, q, date, profile])


    async function downloadFile(doiNo) {
        const item = data.items.map((x, i) => ({
            ...x,
            loading: doiNo === x?.DoiNo && true
        }))
        setData({ ...data, items: item })
        const convertDoiNo = encodeURIComponent(doiNo)
        const res = await api.get(SALE_CONFIG.requests.saleDoi.url + `/${convertDoiNo}/pdf`, {
            responseType: 'arraybuffer'
        })
        const buffer = res.data
        const blob = new Blob([buffer], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        window.open(url, '_blank');
        const itemf = data.items.map((x, i) => ({
            ...x,
            loading: doiNo === x?.DoiNo && false
        }))
        setData({ ...data, items: itemf })
    }
    async function CancelDoi(DoiNo) {
        Swal.fire({
            title: 'ยืนยันการยกเลิก',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#4ab866',
            cancelButtonColor: '#d33',
        }).then((result) => {
            if (result.isConfirmed) {
                const convertDoiNo = encodeURIComponent(DoiNo)
                const url = SALE_CONFIG.requests.saleDoi.url + `/${convertDoiNo}/cancel`

                const Cancel = async () => {
                    const res = await api.put(url, null)
                    const data = res.data
                    if (data.status === true) {
                        getData()
                        Swal.fire(
                            'Good job!',
                            'ยกเลิกเรียบร้อย',
                            'success'
                        )
                    }
                }
                Cancel()

            }

        })
    }

    return (
        <Page>
            <div class="card-content mt-4">
                <div class="container-fluid">

                    <div class=" d-flex row justify-content-between align-items-baseline">
                        <div class="col-lg-3 col-md-12 text-left ">
                            <label class="title-content mb-4">
                                รายการขายเมล็ดพันธุ์
                            </label>
                        </div>
                        <div class="col-lg-9 col-md-12 text-left " style={{display:'flex', justifyContent:'end'}}>
                        {profile?.BranchNo?.BranchNo === '00' &&
                        <div class="col-lg-3 col-md-12 ">
                            <Box className='backgroundField' sx={{ marginRight: '20px' }}>
                                <FormControl variant="standard" fullWidth >
                                    <Select value={branchsNo || 'all'} onChange={e => setSearchParams({ b: e.target.value, q: q, date: date })} 
                                    disableUnderline 
                                    MenuProps={{ PaperProps: { sx: { maxHeight: 400 } } }}
                                    >
                                        <MenuItem value='all'>ทั้งหมด</MenuItem>

                                        {branchs?.map((x, i) => (
                                            <MenuItem value={x?.BranchNo}>{x?.BranchName}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Box>
                        </div>
                        } 
                        <div class="col-lg-3 col-md-12 ">

                            <Box className='backgroundField' sx={{ marginRight: '20px' }}>
                                <MobileDatePicker
                                    dayOfWeekFormatter={(day) => `${day}`}
                                    value={date ? dayjs(date) : ''} onChange={e => setSearchParams({ date: dayjs(e).format('YYYY-MM-DD'), q: q, b: branchsNo })}
                                    slotProps={{ textField: { variant: 'standard', placeholder: 'วันที่ขาย', fullWidth: true, InputProps: { disableUnderline: true }, value: date === 'null' ? '' : date ? dayjs(date) : '' } }}
                                    slots={{
                                        textField: BrowserInput,
                                    }}
                                />
                                {date !== 'null' && date !== null && <span style={{ cursor: 'pointer' }} onClick={() => setSearchParams({ date: null, q: q, b: branchsNo })}>X</span>}
                            </Box>
                        </div>
                        <div class="col-lg-3 col-md-12">
                            <Box className='backgroundField'>
                                <TextField value={q} onChange={e => setSearchParams({ q: e.target.value, b: branchsNo, date: date })} variant="standard" fullWidth placeholder="ค้นหา เลขที่เอกสาร"
                                    InputProps={{
                                        disableUnderline: true,
                                        startAdornment: <Box sx={{ marginRight: '10px' }}><FontAwesomeIcon icon={faSearch} /></Box>,
                                    }}
                                />
                            </Box>
                        </div>
                        </div>
                    </div>

                    <div class="listData row">
                    {loading ? <Skeleton variant="rounded" sx={{ width: '100%', height: '70vh' }} /> :
                        <div class="col-md-12 table-responsive-sm pb-3">
                            <table class="table table-borderless table-hover ">
                                <thead>
                                    <tr>
                                        <th class="text-center">ที่</th>
                                        <th class="text-center">ศูนย์เมล็ดพันธุ์ข้าว</th>
                                        <th class="text-center">วันที่</th>
                                        <th class="text-center">ชื่อผู้ซื้อ</th>
                                        <th class="text-center">ประเภทผู้ซื้อ</th>
                                        <th class="text-center">ตำบล</th>
                                        <th class="text-center">อำเภอ</th>
                                        <th class="text-center">จังหวัด</th>
                                        <th class="text-center">พันธุ์</th>
                                        <th class="text-center">ปริมาณ (กิโลกรัม)</th>
                                        <th class="text-center">เลขที่ DOI</th>
                                        <th class="text-center">สถานะ</th>
                                        <th class="text-center"></th>
                                    </tr>
                                </thead>
                                <tbody class="">
                                    {data?.items?.map((x, i) => (
                                        <tr class="cp" style={{ cursor: 'pointer', backgroundColor: id === x?.AdjustNo ? 'rgb(204, 204, 204) !important' : '' }} >
                                            <td class="text-center" onClick={() => {
                                                navigate(`/sale/coppy-list/${encodeURIComponent(x.DoiNo)}`)
                                            }}> {(data?.meta?.currentPage - 1) * data?.meta?.itemsPerPage + 1 + i}</td>
                                            <td class="text-center" onClick={() => navigate(`/sale/coppy-list/${encodeURIComponent(x.DoiNo)}`)}>{x?.BranchName}</td>
                                            <td class="text-center" onClick={() => navigate(`/sale/coppy-list/${encodeURIComponent(x.DoiNo)}`)}>{dayjs(x?.DocumentDate).format('DD/MM/BBBB')}</td>
                                            <td class="text-center" onClick={() => navigate(`/sale/coppy-list/${encodeURIComponent(x.DoiNo)}`)}>{x?.CustomerName}</td>
                                            <td class="text-center" onClick={() => navigate(`/sale/coppy-list/${encodeURIComponent(x.DoiNo)}`)}>{x?.CustomerTypeName}</td>
                                            <td class="text-center" onClick={() => navigate(`/sale/coppy-list/${encodeURIComponent(x.DoiNo)}`)}>{x?.SubDistrict}</td>
                                            <td class="text-center" onClick={() => navigate(`/sale/coppy-list/${encodeURIComponent(x.DoiNo)}`)}>{x?.District}</td>
                                            <td class="text-center" onClick={() => navigate(`/sale/coppy-list/${encodeURIComponent(x.DoiNo)}`)}>{x?.Province}</td>
                                            <td class="text-center" onClick={() => navigate(`/sale/coppy-list/${encodeURIComponent(x.DoiNo)}`)}>{x?.CatalogName}</td>
                                            <td class="text-center" onClick={() => navigate(`/sale/coppy-list/${encodeURIComponent(x.DoiNo)}`)}>{x?.Qty.toLocaleString()}</td>
                                            <td class="text-center" onClick={() => navigate(`/sale/coppy-list/${encodeURIComponent(x.DoiNo)}`)}>{x?.DoiNo}</td>
                                            <td class="text-center" onClick={() => navigate(`/sale/coppy-list/${encodeURIComponent(x.DoiNo)}`)}>
                                                {x.Status === 'Y' ?
                                                    <span class="status-active">
                                                        ปกติ
                                                    </span> : <span class="status-inactive">
                                                        ยกเลิก
                                                    </span>}
                                            </td>
                                            <td class="text-center">
                                                <div>
                                                    {/* {x?.Status === 'Y' && <Button onClick={() => downloadFile(x.DoiNo)} variant='outlined' startIcon={<FontAwesomeIcon icon={faPrint} />} sx={{ width: '120px', padding: "6px 10px", fontSize: '12px' }}>Download</Button>} */}
                                                    {x?.Status === 'Y' && <Button onClick={() => downloadFile(x.DoiNo)} variant='outlined' startIcon={<FontAwesomeIcon icon={faPrint} />} sx={{ width: '120px', padding: "6px 10px", fontSize: '12px' }}>{x?.loading ? <CircularProgress size={'18px'} color="inherit" /> : 'ดาวน์โหลด'}</Button>}
                                                    {/* {x?.Status === 'Y' && profile?.BranchNo?.BranchNo === '00' ? <Button onClick={() => CancelDoi(x.DoiNo)} variant='outlined' color='error' sx={{ width: '110px', marginLeft: '10px', padding: "6px 10px", fontSize: '12px' }}>ยกเลิก</Button> : null}  */}
                                                </div>

                                            </td>


                                        </tr>
                                    ))}

                                </tbody>
                            </table>
                        </div>}
                        <div class="col-md-12 text-center mt-4">
                            <Pagination sx={{ display: 'flex', justifyContent: 'center' }} color="primary" count={data?.meta?.totalPages} page={+page} onChange={(event, value) => setSearchParams({ page: value, q: q, b: branchsNo, date: date })} shape="rounded" />
                        </div>
                    </div>
                </div>
            </div>
        </Page>
    )
}
